/**
 * 前端设置 store — 目前仅调试模式开关 (localStorage 持久化)
 * 调试模式开启后，左侧导航显示「邮件测试」菜单
 */
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SettingsState {
  debugMode: boolean
  setDebugMode: (v: boolean) => void
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      debugMode: false,
      setDebugMode: (v) => set({ debugMode: v }),
    }),
    { name: 'mailman-settings' },
  ),
)
